import {
  CreateMemberAdjustment,
  CreateMemberAdjustmentConfirmation
} from '@bo-components/members/memberAdjustments';
import { CloseModalButton } from '@library/components/buttons';
import { Modal } from '@library/components/modals/Modal';
import { useMemberCreateAdjustments } from '@bo-hooks/members';

export interface CreateMembeAdjusmentModalProps {
  memberId: string;
  onCancelModal: () => void;
}

export const CreateMemberAdjustmentModal = ({
  memberId,
  onCancelModal
}: CreateMembeAdjusmentModalProps) => {
  const {
    adjustment,
    adjustmentFormValidationErrors,
    adjustmentTypes,
    adjustmentReasonOptions,
    isCreateMemberAdjustmentApiUninitialized,
    createMemberAdjustmentError,
    isCreateMemberAdjustmentError,
    isCreateMemberAdjustmentLoading,
    isCreateMemberAdjustmentSuccess,
    isConfirmAdjustment,
    onClickBack,
    onConfirmCreateAdjustment,
    onSaveAdjustment,
    onUpdateAdjustmentErrors,
    onResetCreateMemberAdjustmentApi,
    onChangeAdjustment
  } = useMemberCreateAdjustments({ memberId });

  const handleCloseModal = () => {
    onResetCreateMemberAdjustmentApi();
    onCancelModal();
  };

  return (
    <Modal
      isOpen
      onCancelModal={handleCloseModal}
      testId="create-adjusment-modal"
    >
      <div className="bg-soFresh-110 border-soFresh-140 relative mx-auto w-[35rem] flex-col overflow-y-auto rounded-md border">
        <div className="text-soClean-100 border-soFresh-140 flex items-center justify-between rounded-t border-b border-solid px-6 py-4 font-medium">
          <h2>
            {isConfirmAdjustment ? 'Confirm Adjustment' : 'Create Adjustment'}
          </h2>
          <CloseModalButton
            btnClassName="p-0"
            handleOnClick={handleCloseModal}
            labelClassName="text-soClean-180 size-6"
            useDefaultStyling={false}
          />
        </div>
        <div className="max-h-[70vh]">
          {isConfirmAdjustment ? (
            <CreateMemberAdjustmentConfirmation
              adjustment={adjustment}
              adjustmentReasonOptions={adjustmentReasonOptions}
              createMemberAdjustmentError={createMemberAdjustmentError}
              isCreateMemberAdjustmentApiUninitialized={
                isCreateMemberAdjustmentApiUninitialized
              }
              isCreateMemberAdjustmentError={isCreateMemberAdjustmentError}
              isCreateMemberAdjustmentLoading={isCreateMemberAdjustmentLoading}
              isCreateMemberAdjustmentSuccess={isCreateMemberAdjustmentSuccess}
              onClickBack={onClickBack}
              onClickClose={onCancelModal}
              onConfirmAdjustment={onConfirmCreateAdjustment}
            />
          ) : (
            <CreateMemberAdjustment
              adjustment={adjustment}
              adjustmentFormValidationErrors={adjustmentFormValidationErrors}
              adjustmentReasonOptions={adjustmentReasonOptions}
              adjustmentTypes={adjustmentTypes}
              onUpdateAdjustmentErrors={onUpdateAdjustmentErrors}
              onChangeAdjustment={onChangeAdjustment}
              onCancelModal={onCancelModal}
              onSaveAdjustment={onSaveAdjustment}
            />
          )}
        </div>
      </div>
    </Modal>
  );
};
